import { projectFirestore } from '../firebase/config';
import { ref } from 'vue';
import appendHtml from 'appendhtml';

const getCustomCss = () => {
  const isCustomCss = (id, location, doc = undefined) => {
    if(doc) {
      const style = document.getElementById('customCss');
      let libDoc = doc;
      if (location == 'widget') {
        if (libDoc.widgetTheme && libDoc.widgetTheme.isCustomCss == true) {
          appendHtml(libDoc.widgetTheme.customCss, style);
        }
      }
      if (location == 'theme') {
        if (libDoc.publicHelpCenterTheme !== undefined && libDoc.publicHelpCenterTheme.isCustomCss == true) {
          appendHtml(libDoc.publicHelpCenterTheme.customCss, style);
          // console.log('style.innerText', style.innerText)
        }
      }
    } else {
      projectFirestore
        .collection('SupportLibraries')
        .doc(id)
        .get()
        .then(doc => {
          if (doc.exists) {
            const style = document.getElementById('customCss');
            // style.innerHTML = '';
            if (location == 'widget') {
              if (doc.data().widgetTheme && doc.data().widgetTheme.isCustomCss == true) {
                appendHtml(doc.data().widgetTheme.customCss, style);
              }
            }
            if (location == 'theme') {
              if (doc.data().publicHelpCenterTheme !== undefined && doc.data().publicHelpCenterTheme.isCustomCss == true) {
                appendHtml(doc.data().publicHelpCenterTheme.customCss, style);
                // console.log('style.innerText', style.innerText)
              }
            }
          }
        });
    }
  };
  return {
    isCustomCss,
  };
};

export default getCustomCss;
